module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pts"
  }, [(_vm.fatalLoadError) ? _c('div', {
    staticClass: "pts-loading"
  }, [_c('div', {
    staticClass: "pts-error"
  }, [_c('p', {
    staticClass: "pts-error-title"
  }, [_vm._v("Could not load product tracking settings")]), _vm._v(" "), _c('p', {
    staticClass: "pts-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "pts-btn pts-btn-outline",
    on: {
      "click": _vm.fetchSettings
    }
  }, [_vm._v("Retry")])])]) : _c('div', {
    staticClass: "pts-shell"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoadingOverlay),
      expression: "showLoadingOverlay"
    }],
    staticClass: "pts-loading pts-loading--overlay",
    attrs: {
      "aria-busy": "true"
    }
  }, [_c('div', {
    staticClass: "pts-spinner"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pts-shell-body",
    class: {
      'pts-shell-body--inactive': _vm.showLoadingOverlay
    }
  }, [(_vm.loadError && !_vm.fatalLoadError) ? _c('div', {
    staticClass: "pts-inline-error"
  }, [_c('p', {
    staticClass: "pts-inline-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchSettings
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-card"
  }, [_c('p', {
    staticClass: "pts-filter-hint"
  }, [_vm._v("Filter by account & marketplace — select one or both to narrow results")]), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-main"
  }, [_c('div', {
    staticClass: "pts-filter-group"
  }, [_c('label', {
    staticClass: "pts-filter-label"
  }, [_vm._v("Storefront")]), _vm._v(" "), _c('div', {
    staticClass: "pts-pills pts-pills--cols-2"
  }, [_c('button', {
    class: ['pts-pill', {
      active: _vm.selectedStorefront === 'all'
    }],
    on: {
      "click": function($event) {
        return _vm.setStorefront('all')
      }
    }
  }, [_vm._v("All accounts")]), _vm._v(" "), _vm._l((_vm.storefronts), function(acc) {
    return _c('button', {
      key: acc.sellerId,
      class: ['pts-pill', {
        active: String(_vm.selectedStorefront) === String(acc.sellerId)
      }],
      on: {
        "click": function($event) {
          return _vm.setStorefront(acc.sellerId)
        }
      }
    }, [_vm._v(_vm._s(acc.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-divider",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-group pts-filter-group-mp"
  }, [_c('label', {
    staticClass: "pts-filter-label"
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('div', {
    staticClass: "pts-pills pts-pills--cols-2 pts-pills--mp"
  }, [_c('button', {
    class: ['pts-pill', {
      active: _vm.selectedMarketplace === 'all'
    }],
    on: {
      "click": function($event) {
        return _vm.setMarketplace('all')
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.availableMarketplaces), function(mp) {
    return _c('button', {
      key: mp.code,
      class: ['pts-pill', {
        active: _vm.selectedMarketplace === mp.code
      }],
      on: {
        "click": function($event) {
          return _vm.setMarketplace(mp.code)
        }
      }
    }, [(_vm.mpEmoji(mp.code)) ? _c('span', {
      staticClass: "pts-mp-emoji",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(_vm._s(_vm.mpEmoji(mp.code)))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(mp.label))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-search-col"
  }, [_c('div', {
    staticClass: "pts-search-wrap"
  }, [_c('svg', {
    staticClass: "pts-search-icon",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "pts-search-input",
    attrs: {
      "id": "pts-search-input",
      "type": "search",
      "placeholder": "Search ASIN or name..."
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "pts-summary-bar"
  }, [_c('span', {
    staticClass: "pts-summary"
  }, [_vm._v("\n        Showing "), _c('strong', [_vm._v(_vm._s(_vm.summaryFilteredCount))]), _vm._v(" products\n        · "), _c('strong', [_vm._v(_vm._s(_vm.ignoredCount))]), _vm._v(" ignored\n        "), (_vm.ignoredCount > 0) ? [_vm._v(" · alerts suppressed")] : _vm._e()], 2), _vm._v(" "), _c('label', {
    staticClass: "pts-show-ignored"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showIgnoredOnly),
      expression: "showIgnoredOnly"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showIgnoredOnly) ? _vm._i(_vm.showIgnoredOnly, null) > -1 : (_vm.showIgnoredOnly)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showIgnoredOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showIgnoredOnly = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showIgnoredOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showIgnoredOnly = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pts-show-ignored-box"
  }), _vm._v(" "), _c('span', [_vm._v("Show ignored only")])])]), _vm._v(" "), (_vm.bulkIgnoreAvailable) ? _c('div', {
    staticClass: "pts-bulk-ignore"
  }, [_c('span', {
    staticClass: "pts-bulk-ignore-scope"
  }, [_vm._v("All products in "), _c('strong', [_vm._v(_vm._s(_vm.bulkIgnoreScopeLabel))]), (_vm.searchTextTrimmed) ? [_vm._v(" matching “" + _vm._s(_vm.searchTextTrimmed) + "”")] : _vm._e(), _vm._v(":")], 2), _vm._v(" "), _c('div', {
    staticClass: "pts-bulk-ignore-actions"
  }, [(_vm.bulkIgnoreEstimate(true) !== 0) ? _c('button', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.bulkIgnoreBusy || _vm.hasChanges,
      "title": _vm.hasChanges ? 'Save or discard your changes first' : ''
    },
    on: {
      "click": function($event) {
        return _vm.startBulkIgnore(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.bulkIgnoreButtonLabel(true)))]) : _vm._e(), _vm._v(" "), (_vm.bulkIgnoreEstimate(false) !== 0) ? _c('button', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.bulkIgnoreBusy || _vm.hasChanges,
      "title": _vm.hasChanges ? 'Save or discard your changes first' : ''
    },
    on: {
      "click": function($event) {
        return _vm.startBulkIgnore(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.bulkIgnoreButtonLabel(false)))]) : _vm._e()]), _vm._v(" "), (_vm.bulkIgnoreMessage) ? _c('p', {
    staticClass: "pts-bulk-result",
    class: 'pts-bulk-result--' + _vm.bulkIgnoreLevel
  }, [_vm._v(_vm._s(_vm.bulkIgnoreMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pts-bulk-card"
  }, [_c('h3', {
    staticClass: "pts-bulk-title"
  }, [_vm._v("Bulk update (CSV)")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pts-bulk-actions"
  }, [_c('button', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.bulkCsvDownloading
    },
    on: {
      "click": _vm.downloadBulkCsvExport
    }
  }, [_vm._v(_vm._s(_vm.bulkCsvDownloading ? 'Downloading…' : 'Download product CSV'))]), _vm._v(" "), _c('label', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm pts-bulk-file-label",
    class: {
      'pts-bulk-file-label--busy': _vm.bulkCsvUploading
    }
  }, [_c('input', {
    staticClass: "pts-bulk-file-input",
    attrs: {
      "type": "file",
      "accept": ".csv,text/csv,text/plain",
      "disabled": _vm.bulkCsvUploading
    },
    on: {
      "change": _vm.onBulkCsvFile
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pts-bulk-file-text"
  }, [_vm._v(_vm._s(_vm.bulkCsvUploading ? 'Uploading…' : 'Upload CSV'))])])]), _vm._v(" "), (_vm.bulkCsvResult) ? _c('p', {
    staticClass: "pts-bulk-result",
    class: _vm.bulkCsvResultLevel
  }, [_vm._v(_vm._s(_vm.bulkCsvResult))]) : _vm._e(), _vm._v(" "), (_vm.bulkCsvErrors.length) ? _c('ul', {
    staticClass: "pts-bulk-errors"
  }, _vm._l((_vm.bulkCsvErrors), function(errLine, idx) {
    return _c('li', {
      key: 'bulk-csv-err-' + idx
    }, [_vm._v(_vm._s(errLine))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pts-table-wrap"
  }, [_c('table', {
    staticClass: "pts-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [(_vm.tableRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "pts-empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No products match the current filters.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableRows), function(product, rowIdx) {
    return _c('tr', {
      key: product.productId != null ? product.productId : ('pts-row-' + rowIdx),
      staticClass: "pts-row"
    }, [_c('td', {
      staticClass: "pts-cell-product"
    }, [_c('div', {
      staticClass: "pts-product-wrap"
    }, [_c('a', {
      staticClass: "pts-product-img-link",
      attrs: {
        "href": product.productPage,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [(product.imageUrl) ? _c('img', {
      staticClass: "pts-product-img",
      attrs: {
        "src": product.imageUrl,
        "alt": product.productName || ''
      }
    }) : _c('div', {
      staticClass: "pts-product-img-placeholder"
    }, [_c('svg', {
      attrs: {
        "width": "20",
        "height": "20",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
        "clip-rule": "evenodd"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "pts-product-info"
    }, [_c('span', {
      staticClass: "pts-product-name"
    }, [_vm._v(_vm._s(product.productName || product.asin1))]), _vm._v(" "), _c('span', {
      staticClass: "pts-product-asin"
    }, [_vm._v(_vm._s(product.asin1))])])])]), _vm._v(" "), _c('td', {
      staticClass: "pts-cell-storefront"
    }, [_vm._v(_vm._s(_vm.storefrontNameFor(product)))]), _vm._v(" "), _c('td', {
      staticClass: "pts-cell-mp"
    }, [_c('span', {
      staticClass: "pts-mp-badge"
    }, [(_vm.mpEmoji(product.marketplaceIso31662Code)) ? _c('span', {
      staticClass: "pts-mp-emoji",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(_vm._s(_vm.mpEmoji(product.marketplaceIso31662Code)))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.mpLabel(product.marketplaceIso31662Code)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "pts-cell-shortname"
    }, [_c('input', {
      staticClass: "pts-shortname-input",
      attrs: {
        "type": "text",
        "autocomplete": "off",
        "data-lpignore": "true"
      },
      domProps: {
        "value": product.shortName
      },
      on: {
        "input": function($event) {
          return _vm.onShortNameInput(product, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "pts-cell-ignore"
    }, [_c('label', {
      staticClass: "pts-toggle"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": !product.show
      },
      on: {
        "change": function($event) {
          return _vm.onToggleIgnore(product)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "pts-toggle-slider"
    })])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pts-pagination"
  }, [_c('span', {
    staticClass: "pts-page-label"
  }, [_vm._v("Page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('div', {
    staticClass: "pts-page-controls"
  }, [_c('button', {
    staticClass: "pts-page-btn",
    attrs: {
      "disabled": _vm.currentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(0)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "pts-page-btn",
    attrs: {
      "disabled": _vm.currentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage - 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "pts-page-num"
  }, [_vm._v(_vm._s(_vm.currentPage + 1) + " / " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('button', {
    staticClass: "pts-page-btn",
    attrs: {
      "disabled": _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage + 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "pts-page-btn",
    attrs: {
      "disabled": _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.totalPages - 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0zm-4 0a1 1 0 010-1.414L10.586 10 6.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
      "clip-rule": "evenodd"
    }
  })])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "pts-slide-up"
    }
  }, [(_vm.hasChanges) ? _c('div', {
    staticClass: "pts-changes-bar"
  }, [_c('span', {
    staticClass: "pts-changes-text"
  }, [_c('span', {
    staticClass: "pts-changes-dot"
  }), _vm._v("\n          You have unsaved changes\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pts-changes-actions"
  }, [_c('button', {
    staticClass: "pts-btn pts-btn-outline",
    on: {
      "click": _vm.discard
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('button', {
    staticClass: "pts-btn pts-btn-primary",
    class: {
      'pts-btn-loading': _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save changes")])])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pts-header"
  }, [_c('h2', {
    staticClass: "pts-title"
  }, [_vm._v("Product Tracking Settings")]), _vm._v(" "), _c('p', {
    staticClass: "pts-subtitle"
  }, [_vm._v("Manage which products SentryKit monitors. Ignored products won't generate alerts but remain in your catalog.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pts-bulk-desc"
  }, [_vm._v("\n        Upload a CSV with headers "), _c('strong', [_vm._v("asin")]), _vm._v(", "), _c('strong', [_vm._v("marketplace")]), _vm._v(", and "), _c('strong', [_vm._v("ignore")]), _vm._v(".\n        Marketplace codes match the filters (e.g. "), _c('code', [_vm._v("us")]), _vm._v(", "), _c('code', [_vm._v("uk")]), _vm._v(", "), _c('code', [_vm._v("de")]), _vm._v(").\n        "), _c('strong', [_vm._v("ignore")]), _vm._v(": "), _c('code', [_vm._v("true")]), _vm._v(" / "), _c('code', [_vm._v("false")]), _vm._v(", "), _c('code', [_vm._v("yes")]), _vm._v(" / "), _c('code', [_vm._v("no")]), _vm._v(", or "), _c('code', [_vm._v("1")]), _vm._v(" / "), _c('code', [_vm._v("0")]), _vm._v(".\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "pts-th-product"
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "pts-th-storefront"
  }, [_vm._v("Storefront")]), _vm._v(" "), _c('th', {
    staticClass: "pts-th-mp"
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('th', {
    staticClass: "pts-th-shortname"
  }, [_vm._v("Short-hand name")]), _vm._v(" "), _c('th', {
    staticClass: "pts-th-ignore"
  }, [_vm._v("Ignore")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3f63c28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ProductTrackingSettings.vue
// module id = 809
// module chunks = 2